module.exports = __webpack_public_path__ + "static/img/box.172f5c08.png";